import { DEFAULT_SLIPPAGE_BPS } from "../../utils/amount/slippage";
import {
  DEFAULT_DIRECTION_SCHEME,
  DIRECTION_PRESETS,
} from "../../utils/directionColors";
import {
  ISettingsContextType,
  OptionsChainSettings,
  SettingsEnum,
  SettingsEnumToTitle,
  SFXSettings,
} from "./types";

export const settingsEnumTitle: SettingsEnumToTitle = {
  [SettingsEnum.OPTIONS_CHAIN]: "options_chain",
  [SettingsEnum.SFX]: "sfx",
  [SettingsEnum.LANGUAGE]: "language",
  [SettingsEnum.DIRECTION_COLORS]: "colors",
  [SettingsEnum.CUSTOM_DIRECTION]: "colors",
  [SettingsEnum.MARKET_SLIPPAGE]: "slippage",
};

export const defaultSettings: ISettingsContextType = {
  sfx: new Set<SFXSettings>([
    "order_placed",
    "order_filled",
    "order_cancelled",
    "yv_deposit",
    "points",
    "error",
  ]),
  addSfx: () => {},
  removeSfx: () => {},

  optionsChain: new Set<OptionsChainSettings>([
    "position",
    "bid_iv",
    "ask_iv",
    "delta",
    "mark_price",
  ]),
  addOptionsChain: () => {},
  removeOptionsChain: () => {},

  language: "en",
  changeLanguage: () => {},

  directionScheme: DEFAULT_DIRECTION_SCHEME,
  customDirection: DIRECTION_PRESETS.classic,
  changeDirectionScheme: () => {},
  setCustomDirection: () => {},
  seedDirectionSchemeFromCountry: () => {},

  slippageBps: DEFAULT_SLIPPAGE_BPS,
  setSlippageBps: () => {},
};
